import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import {
  fetchBoardModify,
  fetchBoardRegister,
  updateBbsTypeCode,
  updateContents,
  updateCopyYn,
  updateNoticeYn,
  updateOpeningYn,
  updateTitle,
  initializeState,
  fetchBoardDelete,
  fetchImageRecognition,
  MyhouseBoardDeleteParam,
  updateFetchStatus,
  updateSelectCategory,
  updateFileSize,
  fetchPenalty,
} from '@Root/slices/myhouse/boardRegisterSlice'
import { RootState } from '@Root/slices'
import { FETCH_STATUS } from '@Root/contants'

export default function useBoardRegister() {
  const dispatch = useDispatch()
  const reduxBoardRegister = useSelector((state: RootState) => state.boardRegister)
  const reduxMyhouse = useSelector((state: RootState) => state.myhouse)

  const validateSymbols = (text: string) => {
    const regExp = /[<>]/gi

    return !regExp.test(text)
  }

  const loadPenalty = useCallback(() => {
    dispatch(fetchPenalty())
  }, [dispatch])

  const loadBoardRegister = useCallback(
    (param, files): void => {
      dispatch(fetchBoardRegister({ param, files, dispatch }))
    },
    [dispatch],
  )

  const loadBoardModify = useCallback(
    (param, files): void => {
      dispatch(fetchBoardModify({ param, files, dispatch }))
    },
    [dispatch],
  )

  const loadBoardDelete = useCallback(
    (param: MyhouseBoardDeleteParam): void => {
      dispatch(fetchBoardDelete(param))
    },
    [dispatch],
  )

  const loadImageRecognition = useCallback(
    (file: File): void => {
      dispatch(fetchImageRecognition(file))
    },
    [dispatch],
  )

  const setSelectCategory = useCallback(
    (value: string) => {
      dispatch(updateSelectCategory(value))
    },
    [dispatch],
  )

  const setTitle = useCallback(
    (value: string) => {
      dispatch(updateTitle(value))
    },
    [dispatch],
  )

  const setContents = useCallback(
    (value: string) => {
      dispatch(updateContents(value))
    },
    [dispatch],
  )

  const setNoticeYn = useCallback(
    (value: boolean) => {
      dispatch(updateNoticeYn(value))
    },
    [dispatch],
  )

  const setOpeningYn = useCallback(
    (value: boolean) => {
      dispatch(updateOpeningYn(value))
    },
    [dispatch],
  )

  const setCopyYn = useCallback(
    (value: boolean) => {
      dispatch(updateCopyYn(value))
    },
    [dispatch],
  )

  const setBbsTypeCode = useCallback(
    (value: string) => {
      dispatch(updateBbsTypeCode(value))
    },
    [dispatch],
  )

  const initFetchStatus = useCallback(() => {
    dispatch(updateFetchStatus(FETCH_STATUS.INITIAL))
  }, [dispatch])

  const setInitialState = useCallback(() => {
    dispatch(initializeState())
  }, [dispatch])

  return {
    reduxBoardRegister,
    reduxMyhouse,
    loadBoardRegister,
    loadBoardModify,
    loadPenalty,
    setSelectCategory,
    setTitle,
    setContents,
    setNoticeYn,
    setOpeningYn,
    setCopyYn,
    setBbsTypeCode,
    initFetchStatus,
    loadBoardDelete,
    loadImageRecognition,
    setInitialState,
    validateSymbols,
  }
}
